import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  CAvatar,
  CListGroupItem,
  CListGroup,
  CContainer,
  CRow,
  CCol,
} from "@coreui/react";
import Header from "./parts/Header";
import "./Front.css";
import Datacontext from "../components/Datacontext";
import axios from "../api/axios";
import ClientSignin from "./ClientSignin";
import { io } from "socket.io-client";

import { UNAUTHORIZED, MISSING_DATA, NO_DATA_FOUND, ERRORS } from "../ERROR";

import useError from "../hooks/useError";

const Front = () => {
  const {
    socketurl,
    store_id,
    ResetData,
    updateClientList,
    updateClientData,
    clientList,
    updateClientCount,
    flag,
  } = useContext(Datacontext);

  const { showError } = useError();

  const navigate = useNavigate();

  useEffect(() => {
    // Check if the value with key "STOREID" exists in local storage
    if (!store_id) {
      // If it doesn't exist, redirect to the login component
      navigate("/login");
    }
  }, [navigate]);

  const handleRemoveData = () => {
    // Remove an item from local storage
    localStorage.removeItem("clientsdata");
    updateClientData([]);
  };

  ResetData();

  const NameCombine = (str) => {
    const firstChars = str
      .split(" ")
      .map((word) => word[0])
      .join("");

    return firstChars;
  };

  const fetchQueData = async () => {
    try {
      const response = await axios.get("/dailyservice/" + store_id);
      updateClientList(response.data.dailyservices);
      updateClientCount(response.data.dailyservices.length);
    } catch (err) {
      if (!err?.response) {
      } else if (err.response?.status === 400) {
        showError(MISSING_DATA, ERRORS.ERROR);
      } else if (err.response?.status === 401) {
        showError(UNAUTHORIZED, ERRORS.ERROR);
      } else {
        showError(NO_DATA_FOUND, ERRORS.ERROR);
      }
    }
  };
  

  useEffect(() => {
    handleRemoveData();
    fetchQueData();
  }, [flag]);

  return (
    <>
      <Header />
      <CContainer>
        <CRow>
          <CCol md={6} className="px-4 py-5">
            <ClientSignin />
          </CCol>
          <CCol md={6} className="d-flex flex-column align-items-center  ">
            <div className="text-black pt-1">
              <h2 style={{ color: "#000" }}>Waiting List</h2>
            </div>

            {clientList.length > 0 && (
              <CListGroup flush className="nameListque">
                {clientList.map((Services, index) => (
                  <CListGroupItem
                    key={index}
                    className="d-flex align-items-center "
                  >
                    {Services.profile_image ? (
                      <>
                        <CAvatar
                          src={Services.profile_image}
                          status="success"
                          size="xl"
                        />
                      </>
                    ) : (
                      <>
                        <CAvatar color="secondary" status="danger" size="xl">
                          {NameCombine(Services.f_name + " " + Services.l_name)}
                        </CAvatar>

                        <span
                          className="ms-md-auto displaytext rounded-circle border d-flex justify-content-center align-items-center"
                          style={{
                            width: "60px",
                            height: "60px",
                          }}
                        >
                          {index + 1}
                        </span>
                      </>
                    )}
                  </CListGroupItem>
                ))}
              </CListGroup>
            )}
          </CCol>
        </CRow>
      </CContainer>
    </>
  );
};

export default Front;
